/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError
} from 'react-router-dom';

const AuthAction = lazy(() => import('@sagano/auth/views/AuthAction'));
const NotFound = lazy(() => import('@sagano/share/views/NotFound'));
function RootErrorBoundary() {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route path="/reset-password" element={lazyView(<AuthAction />)} />
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
